export default function ZoomWrapper({ zoom = 1, children }) {
  // zoom=1 is every current call site (App.js's defaultZoom) — `transform:
  // scale(1)` is a visual no-op but is NOT `transform: none`, so per spec
  // this div still becomes the containing block for every descendant
  // `position: fixed` element (modals etc.), which then centers on THIS
  // div's box instead of the real viewport. Skip the wrapper entirely at
  // zoom=1 so fixed-position descendants resolve against the viewport like
  // everywhere else in the app (see the AddNameModal taloyhtiökortti bug —
  // the report-builder route never wraps in ZoomWrapper and never had this
  // problem).
  if (zoom === 1) return children;
  return (
    <div
      style={{
        transform: `scale(${zoom})`,
        transformOrigin: "top left",
        width: `${100 / zoom}%`,
        height: `${100 / zoom}%`,
      }}
    >
      {children}
    </div>
  );
}